module.exports = __webpack_public_path__ + "img/正确.72f3b602.png";